import { FeedbackTypesEnum } from "@propertelligent/client-api";

/**
 * Tab titles must match GetFeedbackTypes / Add Feedback dropdown (enum Descriptions).
 * Future copy changes: update FeedbackTypesEnum [Description] and this map together.
 */
export const FEEDBACK_TYPE_DISPLAY_LABEL_BY_ID: Record<string, string> = {
  [String(FeedbackTypesEnum.FeatureRequest)]: "Feature Request",
  [String(FeedbackTypesEnum.ProductSupport)]: "Product Support",
  [String(FeedbackTypesEnum.ReportBug)]: "Report Bug",
  [String(FeedbackTypesEnum.DataUpdateRequest)]: "Data Update Request",
  [String(FeedbackTypesEnum.BillingQuestion)]: "Billing Question",
  [String(FeedbackTypesEnum.Other)]: "Other",
};

/**
 * Aggregate API keys → type id.
 * Includes legacy plural keys (deployed aggregates) AND canonical dropdown labels
 * so tabs never disappear when UI/backend roll out at different times.
 */
export const FEEDBACK_LABEL_TO_ID_MAP: Record<string, string> = {
  // Canonical (dropdown / enum Description)
  "Feature Request": String(FeedbackTypesEnum.FeatureRequest),
  "Product Support": String(FeedbackTypesEnum.ProductSupport),
  "Report Bug": String(FeedbackTypesEnum.ReportBug),
  "Data Update Request": String(FeedbackTypesEnum.DataUpdateRequest),
  "Billing Question": String(FeedbackTypesEnum.BillingQuestion),
  Other: String(FeedbackTypesEnum.Other),
  // Legacy aggregate keys still returned by older backends
  "Feature Requests": String(FeedbackTypesEnum.FeatureRequest),
  "Bug Reports": String(FeedbackTypesEnum.ReportBug),
  "Data Requests": String(FeedbackTypesEnum.DataUpdateRequest),
  Billing: String(FeedbackTypesEnum.BillingQuestion),
};

export type FeedbackFilterOption = {
  title: string;
  value: string;
  count: number;
};

/**
 * Builds type filter tabs from aggregateValues: keeps all types, merges
 * legacy/canonical keys by id, and always shows dropdown-matching titles.
 */
export function buildFeedbackTypeFilterOptions(
  aggregateValues: Record<string, number> | null | undefined,
): FeedbackFilterOption[] {
  if (!aggregateValues) return [];

  const countsById: Record<string, number> = {};

  for (const [aggregateKey, count] of Object.entries(aggregateValues)) {
    const typeId = FEEDBACK_LABEL_TO_ID_MAP[aggregateKey];
    if (!typeId) continue;
    countsById[typeId] = (countsById[typeId] ?? 0) + Number(count);
  }

  const preferredOrder = Object.keys(FEEDBACK_TYPE_DISPLAY_LABEL_BY_ID);

  return preferredOrder
    .filter((typeId) => countsById[typeId] != null)
    .map((typeId) => ({
      title: FEEDBACK_TYPE_DISPLAY_LABEL_BY_ID[typeId],
      value: typeId,
      count: countsById[typeId],
    }));
}
